import React from "react";
import PropTypes from "prop-types";
import { Wrapper } from "../Wrapper";
import { TimerBlock } from "./TimerBlock";
import { VoltageBlock } from "./VoltageBlock";

import "./style.scss";

export function Settings(props) {
  return (
    <Wrapper className={`${props.className} ps_settings `}>
      <VoltageBlock
        className="ps_settings_voltage"
        voltage={props.settingsData.voltage}
        current={props.settingsData.current}
        setVoltage={props.setVoltage}
        setCurrent={props.setCurrent}
      />
      <TimerBlock
        className="ps_settings_timer"
        value={props.settingsData.timer}
        setTimer={props.setTimer}
        onClickStart={props.onClickStart}
        onClickStop={props.onClickStop}
        interactionProps={props.interactionProps}
        alert={props.alert}
      />
    </Wrapper>
  );
}

Settings.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * data supplied to settings
   */
  settingsData: PropTypes.shape({
    /**
     * voltage to be displayed
     */
    voltage: PropTypes.number,
    /**
     * current value to be displayed
     */
    current: PropTypes.number,
    /**
     * timer value to be displayed in timer
     */
    timer: PropTypes.instanceOf(Date),
  }),
  /**
   * callback function to set timer value
   */
  setTimer: PropTypes.func,
  /**
   * callback function to set voltage value
   */
  setVoltage: PropTypes.func,
  /**
   * callback function to set current value
   */
  setCurrent: PropTypes.func,
  /**
   * callback function to trigger when clicked start
   */
  onClickStart: PropTypes.func,
  /**
   * callback function to trigger when clicking stop
   */
  onClickStop: PropTypes.func,
};
Settings.defaultProps = {};
